// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// project imports

import Profile from './Profile';
import Notification from './Notification';
import DarkModeToggle from './DarkModeToggle';
import MobileSection from './MobileSection';


// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));


  return (
    <>
      {/* Search has been removed */}      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}


      <DarkModeToggle />
      <Notification />

      {!downLG && <Profile />}

      {downLG && <MobileSection />}
    </>
  );
}
